ArchivedModelView = require 'views/archive/archived-model-view'
Controller = require 'controller'
View = require 'view'
templates = require 'views/internal/templates'
l = require 'lib/localize'
f = require 'effing'


module.exports = class ClosedBoardsView extends View

  initialize: ->
    @listenTo @model.boardList,
      'change:closed add remove reset': @frameDebounce @render

  render: ->
    boards = @model.boardList

    data =
      empty: boards.filter((entry) -> entry.get('closed')).length == 0

    @$el.html(
      templates.fill(
        'closed_boards',
        data
      )
    )

    $list = @$('.js-archive-items')

    subviews = boards.sortBy((board) -> board.get('name').toUpperCase()).filter(f.method('get', 'closed')).map (model) =>
      @subview ArchivedModelView, model,
        onReopen: @onReopen.bind(@)
        reOpenText: l('unarchive board')

    @appendSubviews subviews, $list

    @

  onReopen: (board) -> Controller.displayBoard({ idBoard: board.id }).done()



// WEBPACK FOOTER //
// ./app/scripts/views/archive/closed-boards-view.coffee